import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios, { API, getErrorMessage } from "@/lib/api";
import LoadingScreen from "@/components/shared/LoadingScreen";

export default function JamaahProfil() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/jamaah/profil`).then(({ data }) => setForm(data)).catch(() => {});
  }, []);

  if (!form) return <LoadingScreen />;

  const update = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/jamaah/profil`, { name: form.name, phone: form.phone, address: form.address, city: form.city, province: form.province, emergency_contact: form.emergency_contact });
      toast.success("Profil berhasil diperbarui");
    } catch (e) {
      toast.error(getErrorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="jamaah-profil-page" className="max-w-2xl space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Profil Saya</h1>
        <p className="text-sm text-[#64748B]">Perbarui data pribadi Anda. Perubahan data identitas terverifikasi memerlukan persetujuan admin.</p>
      </div>

      <div className="space-y-4 rounded-2xl bg-white p-6 shadow-[0_2px_10px_rgba(15,107,79,0.05)]">
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Nama Lengkap</Label><Input data-testid="profile-name-input" value={form.name || ""} onChange={(e) => update("name", e.target.value)} /></div>
          <div><Label>Nomor HP</Label><Input data-testid="profile-phone-input" value={form.phone || ""} onChange={(e) => update("phone", e.target.value)} /></div>
        </div>
        <div><Label>Email</Label><Input data-testid="profile-email-input" value={form.email || ""} disabled className="bg-slate-50" /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>NIK</Label><Input data-testid="profile-nik-input" value={form.nik || ""} disabled className="bg-slate-50" /></div>
          <div><Label>Tanggal Lahir</Label><Input data-testid="profile-dob-input" value={form.dob || ""} disabled className="bg-slate-50" /></div>
        </div>
        <div><Label>Alamat</Label><Input data-testid="profile-address-input" value={form.address || ""} onChange={(e) => update("address", e.target.value)} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Kota/Kabupaten</Label><Input data-testid="profile-city-input" value={form.city || ""} onChange={(e) => update("city", e.target.value)} /></div>
          <div><Label>Provinsi</Label><Input data-testid="profile-province-input" value={form.province || ""} onChange={(e) => update("province", e.target.value)} /></div>
        </div>
        <div><Label>Kontak Darurat</Label><Input data-testid="profile-emergency-input" value={form.emergency_contact || ""} onChange={(e) => update("emergency_contact", e.target.value)} placeholder="Nama & nomor HP" /></div>
        <Button data-testid="profile-save-button" disabled={saving} onClick={handleSave} className="rounded-full bg-[#0F6B4F] text-white hover:bg-[#084C3A]">
          {saving ? "Menyimpan..." : "Simpan Perubahan"}
        </Button>
      </div>
    </div>
  );
}
